import  MainRender from "./mainrender"
import {getPortPosition} from "./utils/dom"
import {groupRenderRegister} from "./render/group/index"
import layoutDefault from "../tflow/layout/layoutDefault"
let tflow={}
tflow.init=function(svgDom,groups,links,config){
    this.svgDom = svgDom
    this.groups=groups
    this.links=links
    this.config=config
    return this;
}
tflow.render = function(){
     let instance = new MainRender(this.svgDom,this.groups,this.links,this.config)

     return instance;
}
tflow.layout=function({type,...param}){
    
    if(type == "default" || !type){
        layoutDefault(param,this.groups,this.links)
    }
    return this;
}
tflow.getPortPosition = getPortPosition
tflow.groupRenderRegister = groupRenderRegister

if(window) window.tflow = tflow
export default tflow


// WEBPACK FOOTER //
// ./src/assets/tflow/index.js